/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Separator } from '@/components/ui/separator'
import React, { useEffect } from 'react'
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
  } from "@/components/ui/select"
  import { Progress } from "@/components/ui/progress"
import Alert from '../common/Alert'
import CloseButton from '../common/CloseButton'
import { makeRequest } from '@/utils/axiosInterceptor'
import { useQueryClient, useQuery } from "@tanstack/react-query";
import { Checkbox } from "@/components/ui/checkbox"
import { formatDateForInput, isValidDateRange } from '@/utils/formatDateForInput'
import { toast } from 'sonner'

export default function HospitalEditForm({selected, setSelected}) {
    const queryClient = useQueryClient();
    const [editActive, setEditActive] = React.useState(false)
    const [isSubmitting, setIsSubmitting] = React.useState(false)

    const [deleteAlert, setDeleteAlert] = React.useState(false)
    const [recoverAlert, setRecoverAlert] = React.useState(false)

    const [activateAlert, setActivateAlert] = React.useState(false)
    const [deactivateAlert, setDeactivateAlert] = React.useState(false)
    const [updateAlert, setUpdateAlert] = React.useState(false)


    const [currData, setCurrData] = React.useState(selected)
    const isModified = JSON.stringify(selected) !== JSON.stringify(currData)

    const fetchStorageUsage = async () => {
        try {
            const res = await makeRequest("GET", `/hospitals/storage/${currData.id}`, "");
            return parseFloat(res?.data || 0);
        } catch (err) {
            console.error("Failed to fetch storage usage", err);
            return 0;
        }
    };

    const { data: usedStorage = 0} = useQuery({
        queryKey: ['hospital-storage', currData.id],
        queryFn: fetchStorageUsage,
        enabled: !!currData?.id,
    });

    useEffect(() => {
        setEditActive(false)
        setCurrData(selected)
    }, [selected])

    const updateHospital = async () => {
        try {
            setIsSubmitting(true)
            if (!isValidDateRange(currData.subscription_start, currData.subscription_end)) {
                toast.error('Start must be before end')
                setIsSubmitting(false)
                return
            }
            console.log('update hospital')
            console.log(currData)
            const res = await makeRequest('POST', '/hospitals/update', currData)
            console.log(res);

            if (res?.statusCode && res?.statusCode >= 400) {
                toast.error(res?.message || 'Failed to update hospital')
                setUpdateAlert(false)
                setIsSubmitting(false)
                return
            }

            if (res?.status === 201) {
                queryClient.invalidateQueries({
                    queryKey: ["hospital"],
                });
                setSelected({ ...selected, ...currData })
                setUpdateAlert(false)
                setEditActive(false)
                toast.success('Hospital updated successfully')
            }
        } catch (err) {
            console.log(err)
            toast.error('Failed to update hospital')
        } finally {
            setIsSubmitting(false)
        }
    }

    const recoverDeleteHospital = async () => {
        try {
            let apiRoute = ''
            if (selected.is_deleted === true) {
                console.log('recovering')
                apiRoute = `/hospitals/recover/${selected.id}`
            } else if (selected.is_deleted === false) {
                console.log('deleting')
                apiRoute = `/hospitals/delete/${selected.id}`
            }
            const res = await makeRequest('GET', apiRoute, '')
            if (res?.status === 200) {
                queryClient.invalidateQueries({
                    queryKey: ["hospital"],
                });
                setSelected(res.data)
                setDeleteAlert(false)
                setRecoverAlert(false)
            }
            console.log(res)
        } catch (err) {
            console.log(err)
        }
    }


    const deactivateSubscription = async () => {
        try {
            console.log('deactivate subscription')
            const res = await makeRequest('POST', '/hospitals/deactivate', selected)
            console.log(res);
            if (res?.status === 201) {
                queryClient.invalidateQueries({
                    queryKey: ["hospital"],
                });
                setSelected(res.data)
                setDeactivateAlert(false)
            }
        } catch (err) {
            console.log(err)
        }
    }

    const ativateSubscription = async () => {
        try {
            console.log('activate subscription')
            const res = await makeRequest('POST', '/hospitals/activate', selected)
            console.log(res);
            if (res?.status === 201) {
                queryClient.invalidateQueries({
                    queryKey: ["hospital"],
                });
                setSelected(res.data)
                setActivateAlert(false)
            }
        } catch (err) {
            console.log(err)
        }
    }
  return (
    <div style={{width:'100%'}}>
        <div style={{display:'flex',justifyContent:'space-between', flexDirection:'row'}}>
            <div>
                <span style={{fontWeight:'bold'}}>Editing Hospital : </span>{selected.name} 
            </div>
            <div style={{display:'flex', gap:'0.5vw', alignItems:'center'}}>
                {
                    editActive === true ? 
                    <Button onClick={() => setUpdateAlert(true)} disabled={isSubmitting}>Save Changes</Button>
                    :
                    <Button disabled={editActive} onClick={() => setEditActive(!editActive)}>Edit</Button>
                }

                {
                    selected.is_deleted === false ?
                    <Button onClick={() => setDeleteAlert(true)} className='ml-[0.5vw]' variant="destructive">Delete</Button>
                    :
                    <Button onClick={() => setRecoverAlert(true)} className='ml-[0.5vw]' >Recover</Button>
                }
                
                <CloseButton 
                    onClose={() => setSelected(null)}
                    isModified={isModified}
                    isSubmitting={isSubmitting}
                />
            </div>
            
        </div>
        <Separator className="mt-[1vh]"/>
        <div style={{display:'flex',justifyContent:'space-between', flexDirection:'row', width: '100%'}}>
            <div className=' p-2' style={{width: '50%', height: '75vh', display:'flex', flexDirection:'column', overflowY:'scroll'}}>
                <h2 style={{fontWeight:'bold'}} className='text-lg'>Hospital Details</h2>
                <Separator className="mt-[1vh]"/>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Hospital Name </h5>
                    <Input onChange={(e) => setCurrData({...currData, name: e.target.value})} 
                        disabled={!editActive} value={currData.name} 
                        className='mt-[1vh]' 
                    />
                </div>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Address</h5>
                    <Input 
                        onChange={(e) => setCurrData({...currData, address: e.target.value})} 
                        disabled={!editActive} value={currData.address} className='mt-[1vh]' 
                    />
                </div>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Type</h5>
                    <div className='mt-[1vh]'>
                        <Select 
                            onValueChange={(value) => setCurrData({...currData, type: value})} 
                            disabled={!editActive} value={currData.type}
                        >
                            <SelectTrigger>
                                <SelectValue placeholder="Entity Type" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectGroup>
                                <SelectLabel>Institution Type</SelectLabel>
                                <SelectItem value="Hospital">Hospital</SelectItem>
                                <SelectItem value="Clinic">Clinic</SelectItem>
                                </SelectGroup>
                            </SelectContent>
                        </Select>
                    </div>
                    
                </div>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Email</h5>
                    <Input 
                        onChange={(e) => setCurrData({...currData, email: e.target.value})} 
                        disabled={!editActive} value={currData.email} className='mt-[1vh]' 
                    />
                </div>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Contact</h5>
                    <Input 
                        onChange={(e) => setCurrData({...currData, contact: e.target.value})} 
                        disabled={!editActive} value={currData.contact} className='mt-[1vh]' 
                    />
                </div>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Account Deleted ?</h5>
                    <h5 className='text-sm'>{selected.is_deleted ? "Yes" : "No"}</h5>
                </div>

                <div className='mt-[2vh]'>
                    <h2 style={{fontWeight:'bold'}} className='text-lg'>Model Access</h2>
                    <Separator className="mt-[1vh]"/>
                    <div className='mt-[3vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={true} checked={currData.abnormal_model_access} onCheckedChange={(val) => setCurrData({...currData, abnormal_model_access: val})} id="abnormal" />
                                <label
                                    htmlFor="abnormal"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Abnormal 
                                </label>
                            </div>
                    </div>
                    <div className='mt-[1vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={true} checked={currData.tb_model_access} onCheckedChange={(val) => setCurrData({...currData, tb_model_access: val})} 
                                id="tb" 
                            />
                                <label
                                    htmlFor="tb"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    TB 
                                </label>
                            </div>
                    </div>
                    <div className='mt-[1vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.atelectasis_model_access} onCheckedChange={(val) => setCurrData({...currData, atelectasis_model_access: val, edema_model_access: val})} 
                                id="Atlectasis" 
                            />
                                <label
                                    htmlFor="Atlectasis"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Atlectasis and Edema 
                                </label>
                        </div>
                    </div>
                    <div className='mt-[1vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.cardiomegaly_model_access} onCheckedChange={(val) => setCurrData({...currData, cardiomegaly_model_access: val})} 
                                id="Cardiomegaly" 
                            />
                                <label
                                    htmlFor="Cardiomegaly"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Cardiomegaly
                                </label>
                            </div>
                    </div>
                    <div className='mt-[1vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.consolidation_model_access} onCheckedChange={(val) => setCurrData({...currData, consolidation_model_access: val})} 
                                id="Consolidation"
                            />
                                <label
                                    htmlFor="Consolidation"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Consolidation
                                </label>
                            </div>
                    </div>
                    <div className='mt-[1vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.rheumatic_model_access} onCheckedChange={(val) => setCurrData({...currData, rheumatic_model_access: val})} 
                                id="Rheumatic"
                            />
                                <label
                                    htmlFor="Rheumatic"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Rheumatic
                                </label>
                            </div>
                    </div>
                    <div className='mt-[1vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.pneumothorax_model_access} onCheckedChange={(val) => setCurrData({...currData, pneumothorax_model_access: val})} 
                                id="Pneumothorax"
                            />
                                <label
                                    htmlFor="Pneumothorax"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Pneumothorax
                                </label>
                            </div>
                    </div>
                    <div className='mt-[1vh]'>
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.effusion_model_access} onCheckedChange={(val) => setCurrData({...currData, effusion_model_access: val})} 
                                id="Effusion"
                            />
                                <label
                                    htmlFor="Effusion"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Effusion
                                </label>
                            </div>
                    </div>
                </div>
            </div>
            <Separator orientation="vertical" className="mt-[1vh] h-[73vh]"/>
            <div className=' p-2' style={{width: '50%', height: '75vh', display:'flex', flexDirection:'column'}}>
                <h2 style={{fontWeight:'bold'}} className='text-lg'>Subscription Details</h2>
                <Separator className="mt-[1vh]"/>
                <div className='mt-[2vh]' style={{width:'100%', display: 'flex', flexDirection:'row'}}>
                    <div style={{width:'50%'}}>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Space Allocated</h5>
                        <Input 
                            onChange={(e) => {
                                const val = e.target.value.toLowerCase();
                                if (val === '' || val === 'unlimited') {
                                    setCurrData({...currData, space_allocated: null})
                                } else {
                                    setCurrData({...currData, space_allocated: e.target.value})
                                }
                            }}  
                            disabled={!editActive} 
                            type='text' 
                            value={currData.space_allocated === null ? 'Unlimited' : currData.space_allocated} 
                            className='mt-[1vh]' 
                        />
                    </div>
                    <div className='ml-[0.5vw]' style={{width:'50%'}}>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Users Allocated</h5>
                        <Input 
                            onChange={(e) => setCurrData({...currData, allowed_users: e.target.value})} 
                            disabled={!editActive} type='number' value={currData.allowed_users} className='mt-[1vh]' 
                        />
                    </div>
                </div>
                <div style={{display:'flex', flexDirection: 'row', width:'100%', justifyContent:'center', alignItems:'center'}} className='mt-[2vh]'>
                    <div style={{width:'50%'}}>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Subscription Active ?</h5>
                        <h5 className='text-sm'>{selected.subscription_active ? "Yes" : "No"}</h5>
                    </div>
                    <div style={{width:'50%', display:'flex', justifyContent:'flex-end', alignItems:'center'}}>
                        {
                            selected.subscription_active ? 
                            <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setDeactivateAlert(true)} variant="destructive">Deactivate</Button>:
                            <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setActivateAlert(true)}>Activate</Button>
                        }
                    </div>
                    
                </div>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Subscription Start Date</h5>
                    <Input
                        disabled={!editActive}
                        type='datetime-local'
                        value={formatDateForInput(currData.subscription_start)}
                        onChange={(e) => setCurrData({ ...currData, subscription_start: e.target.value ? new Date(e.target.value).toISOString() : null })}
                        className='mt-[1vh]'
                    />
                </div>
                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Subscription End Date</h5>
                    <Input
                        disabled={!editActive}
                        type='datetime-local'
                        value={formatDateForInput(currData.subscription_end)}
                        onChange={(e) => setCurrData({ ...currData, subscription_end: e.target.value ? new Date(e.target.value).toISOString() : null })}
                        className='mt-[1vh]'
                    />
                </div>

                <h2 style={{fontWeight:'bold'}} className='text-lg mt-[2vh]'>Usage Details</h2>
                <Separator className="mt-[1vh]"/>

                <div className='mt-[2vh]'>
                    <h5 style={{fontWeight:'bold'}} className='text-sm'>Current storage usage</h5>
                    {currData.space_allocated === null ? (
                        <span className='text-xs'>{usedStorage} GB Used / Unlimited</span>
                    ) : (
                        <>
                            <Progress className='mt-[1vh]' value={currData.space_allocated > 0 ? (usedStorage / currData.space_allocated) * 100 : 0} />
                            <span className='text-xs'>
                                {usedStorage}/{currData.space_allocated} GB Used ({currData.space_allocated > 0 ? ((usedStorage / currData.space_allocated) * 100).toFixed(2) : 0}%)
                            </span>
                        </>
                    )}
                </div>
                
            </div>
        </div>


        <Alert
            open={deleteAlert}
            setOpen={setDeleteAlert}
            title="Delete Hospital"
            description ="Are you sure you want to delete this hospital ?"
            action={recoverDeleteHospital}
        />

        <Alert
            open={recoverAlert}
            setOpen={setRecoverAlert}
            title="Recover Hospital"
            description ="Are you sure you want to recover this hospital ?"
            action={recoverDeleteHospital}
        />

        <Alert
            open={updateAlert}
            setOpen={setUpdateAlert}
            title="Updateing Hospital"
            description ="Are you sure you want to make changes to this hospital ?"
            action={updateHospital}
        />

        <Alert
            open={deactivateAlert}
            setOpen={setDeactivateAlert}
            title="Deactivate Subscription"
            description ="Are you sure you want to deactivate the subscription for this hospital ?"
            action={deactivateSubscription}
        />

        <Alert
            open={activateAlert}
            setOpen={setActivateAlert}
            title="Activate Subscription"
            description ="Are you sure you want to activate the subscription for this hospital ?"
            action={ativateSubscription}
        />
    </div>
  )
}
